import '../assets/styles/DevisPanel.css';

/**
 * Fenêtre de confirmation d'une suppression, commune aux listes.
 *
 * `details` : ce qui part avec l'élément, une puce par entrée ; `note` : une
 * phrase sous la liste (ce qui est conservé). Même mise en page que la
 * suppression d'une demande (DemandeDevis), pour qu'on la reconnaisse.
 */
function ConfirmationSuppression({
  titre,
  sousTitre,
  details = [],
  note = null,
  enCours = false,
  // Le message d'en-tête : par défaut, la mise à la corbeille.
  avertissement = (
    <>
      <strong>Mis à la corbeille.</strong> Restaurable pendant 30 jours.
    </>
  ),
  libelleConfirmer = 'Oui, supprimer',
  onAnnuler,
  onConfirmer,
}) {
  return (
    <div className="devis-modal-overlay" onClick={enCours ? undefined : onAnnuler}>
      <div
        className="devis-modal devis-modal-etroit"
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-labelledby="confirmation-suppression-titre"
      >
        <div className="devis-modal-header">
          <div>
            <div className="devis-modal-numero" id="confirmation-suppression-titre">
              {titre}
            </div>
            {sousTitre && <div className="devis-modal-sub">{sousTitre}</div>}
          </div>
          <div className="devis-modal-header-right">
            <button
              type="button"
              className="devis-drawer-close"
              onClick={onAnnuler}
              disabled={enCours}
              aria-label="Fermer"
            >
              ×
            </button>
          </div>
        </div>
        <div className="devis-modal-body">
          <div className="devis-alert devis-alert-erreur">
            {avertissement}
            {details.length > 0 && (
              <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
                {details.map((d, i) => (
                  <li key={i}>{d}</li>
                ))}
              </ul>
            )}
            {note && <div style={{ marginTop: 6 }}>{note}</div>}
          </div>
          <div className="devis-modal-actions">
            <button type="button" className="devis-btn" onClick={onAnnuler} disabled={enCours}>
              Non, garder
            </button>
            <button
              type="button"
              className="devis-btn devis-btn-danger"
              onClick={onConfirmer}
              disabled={enCours}
              autoFocus
            >
              {enCours ? 'En cours…' : libelleConfirmer}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationSuppression;
